module.exports = __webpack_public_path__ + "img/kf.436b90d5.png";